import { Bar } from "react-chartjs-2";
import { Box, useTheme } from "@mui/material";
import { getXAxisUnit, GraphColors } from "./helper";

export const BarChart = ({
  sx,
  // data = dummyData,
  labels = [],
  values = [],
  isMultipleDataSets = false,
  color = "random",
  options = {},
  alignment = "x",
  borderSkipped = undefined,
  xLabel = "",
  yLabel = "",
  startDate = null,
  endDate = null,
  stepSize,
  precision = 0,
  truncateLabelX,
  truncateLabelY,
}) => {
  const xAxisUnit = getXAxisUnit(startDate, endDate);
  const { palette } = useTheme();
  const opt = {
    indexAxis: alignment,
    elements: {
      bar: {
        borderWidth: 0,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: false,
      // title: {
      //   display: true,
      //   text: "Chart.js Horizontal Bar Chart",
      // },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
          lineWidth: 0.5,
          // tick: false,
          // beginAtZero: true,
          // color: (context) => {
          //   console.log(context);
          //   if (context.index === 0) return "";
          //   else return "rgba(102,102,102,0.2)";
          // },
        },
        title: {
          display: !!xLabel,
          text: xLabel,
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 15,
            weight: "400",
            lineHeight: 1.2,
          },
          padding: { top: 20 },
        },
        ticks: {
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 15,
            weight: "400",
          },
          stepSize: stepSize,
          precision: precision,
          ...(truncateLabelX && {
            callback: function (value) {
              const label = this.getLabelForValue(value);
              return label.length > truncateLabelX
                ? label.substring(0, truncateLabelX) + "..."
                : label;
            },
          }),
        },
      },
      y: {
        grid: {
          display: true,
          drawBorder: false,
          lineWidth: 0.5,
          // tick: false,
          // color: (context) => {
          //   console.log(context);
          //   if (context.index === 0) return "red";
          //   else return "rgba(102,102,102,0.2)";
          // },
        },
        title: {
          display: !!yLabel,
          text: yLabel,
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 15,
            weight: "400",
            lineHeight: 1.2,
          },
          padding: { bottom: 20 },
        },
        ticks: {
          color: palette.custom.sub_heading,
          font: {
            family: "Roboto",
            size: 15,
            weight: "400",
          },
          width: "30px",
          stepSize: 1,
          precision: precision,
          ...(truncateLabelY && {
            callback: function (value) {
              const label = this.getLabelForValue(value);
              return label.length > truncateLabelY
                ? label.substring(0, truncateLabelY) + "..."
                : label;
            },
          }),
        },
      },
    },
    ...options,
  };

  const generateData = () => {
    if (isMultipleDataSets) {
      return {
        labels: labels.length ? labels : [startDate, endDate],
        datasets: values.map((v) => ({
          data: v,
          backgroundColor: v.color,
          borderColor: v.color,
          borderRadius: 50,
          borderSkipped: borderSkipped,
        })),
      };
    } else {
      // Adjust bar thickness for single bar charts
      // const isSingleBar = values.length === 1;
      return {
        labels,
        datasets: [
          {
            data: values,
            borderColor: color !== "random" ? color : GraphColors,
            borderRadius: 50,
            borderSkipped: borderSkipped,
            backgroundColor: color !== "random" ? color : GraphColors,
            maxBarThickness: 30,
            barPercentage: 0.9,
            categoryPercentage: 0.8,
          },
        ],
      };
    }
  };

  return (
    <Box sx={{ height: "100%", ...sx }}>
      {/* <Typography
        sx={{
          color: "#666666",
          position: "absolute",
          transform: "rotate(-90deg)",
          transformOrigin: "0 0",
          bottom: "33%",
          fontWeight: "600",
        }}
      >
        x axis label
      </Typography> */}
      <Bar datasetIdKey="id" data={generateData()} options={opt} />
      {/* <Typography
        className="text-align-center"
        sx={{ color: "#666666", fontWeight: "600" }}
      >
        y axis label
      </Typography> */}
    </Box>
  );
};
